// extracted by mini-css-extract-plugin
module.exports = {"section":"_93444fe79c--section--OHB2w","section-heading":"_93444fe79c--section-heading--fmzEr","wrapper":"_93444fe79c--wrapper--KCVQ7","card":"_93444fe79c--card--MeZ65"};